<template>
    <div href class="feed-menu-control"> <!--v-if="unreadInsightsNumber"-->
        <router-link class="navigation-item tag-link" to="/performance/highlights">
            <div class="feed-menu-content">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M21,19V20H3V19L5,17V11C5,7.9 7.03,5.17 10,4.29C10,4.19 10,4.1 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.1 14,4.19 14,4.29C16.97,5.17 19,7.9 19,11V17L21,19M14,21A2,2 0 0,1 12,23A2,2 0 0,1 10,21" /></svg>
                <span class="text">Highlights</span>
            </div>
        </router-link>
        <!--<span class="unread" v-if="showUnread">{{ unreadInsightsNumber }}</span>-->
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'FeedMenuControl',
        computed: {
            ...mapGetters(['unreadInsightsNumber']),
            showUnread() {
                return this.unreadInsightsNumber > 0;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @use 'sass:math';
    @import '../styles/base';
    @import '../../node_modules/hd-styles/modules/mixins';

    .feed-menu-control {
        position: relative;
    }

    svg {
        fill: $white;
        width: 20px;
        display: block;
    }

    .unread {
        @include rem(font-size, 12px);
        position: absolute;
        display: block;
        width: $spacing-unit;
        height: $spacing-unit;
        background-color: $red;
        border-radius: 50%;
        pointer-events: none;
        color: $white;
        text-align: center;
        top: 8px;
        left: 12px;
        line-height: $spacing-unit;
        font-weight: 600;
    }

    .text {
        margin-left: math.div($spacing-unit, 2);

        @include bp('medium-large-down') {
            @include visually-hidden;
        }
    }

    .feed-menu-content {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
    }

    @include bp('medium-large-down') {
        .feed-menu-control {
            display: flex;
            justify-content: center;
        }

        .feed-menu-control > .navigation-item {
            display: flex;
            justify-content: center;
        }

        .feed-menu-content {
            justify-content: center;
        }
    }
</style>